import * as React from 'react';
import { safe, isNullOrUndefined, getCurrencySymbol, exportToCsv, getbaseURL, downloadPDF, addItemToGoogleTracking, isNullOrWhitespace } from "../../utils";
import { IPageProperties, ITimeseries } from "../../models";
import { BackToTop, Disclaimer } from "../../assets";
import { NumberFormat } from "../../assets/NumberFormat/NumberFormat";

const moment = require('moment');
const Datetime = require('react-datetime');
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const FaAngleLeft = require('react-icons/lib/fa/angle-left');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
const styles = require('./styles.pcss');
const DEFAULT_START_DATE = '01/01/1970'
const DATE_FORMAT = 'DD/MM/YYYY'

interface IHistoricalPrices {
    shareclass_price?: number;
    date?: string;
    local_bid_price?: number;
    local_offer_price?: number;
    value?: number;
}

interface IHistoricalSharePrices {
    shareclass_price?: number;
    date?: string;
    local_bid_price?: number;
    local_offer_price?: number;
    value?: number;
}

interface IDistributionRates {
    date?: string;
    payment_type?: string;
    income_type?: string;
    value?: number;
    xd_date?: string;
}

interface IHistoricalNavPrices {
    value?: number;
    ccy?: string;
    percentage_price_change?: number;
    absolute_price_change?: number;
    date?: string;
}

interface IState {
    startDate?: string;
    endDate?: string;
    selectedEndDate?: string,
    selectedStartDate?: string,
    historicalPage?: number;
    historicalSharePage?: number;
    historicalNavPage?: number;
    historicalPageAll?: IHistoricalPrices[];
    historicalSharePageAll?: IHistoricalSharePrices[];
    historicalNavPageAll?: IHistoricalNavPrices[];
    distributionPage?: number;
    distributionPageAll?: IDistributionRates[];
    pageLimit?: number;
    sharePricesPageLimit?: number;
}

export class PageHistoric extends React.Component<IPageProperties, IState> {
    constructor(props) {
        super(props);

        this.state = {
            startDate: moment(DEFAULT_START_DATE, DATE_FORMAT),
            endDate: moment(),
            selectedStartDate: moment(DEFAULT_START_DATE, DATE_FORMAT),
            selectedEndDate: '',
            historicalPage: 0,
            historicalNavPage: 0,
            historicalSharePage: 0,
            distributionPage: 0,
            pageLimit: 10,
            sharePricesPageLimit: 10,
            historicalPageAll: [],
            historicalSharePageAll: [],
            distributionPageAll: [],
            historicalNavPageAll: [],
        };

        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.goToEnd = this.goToEnd.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.goToStart = this.goToStart.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.getDateRangeData = this.getDateRangeData.bind(this);
        this.exportCSV = this.exportCSV.bind(this);
        this.checkDate = this.checkDate.bind(this);
    }

    componentDidMount() {
        const shareClassLaunchDate = this.props.shareClass.properties.launch_date;
        const startDate = !isNullOrWhitespace(shareClassLaunchDate) && !isNullOrUndefined(shareClassLaunchDate) ? moment(shareClassLaunchDate) : moment(DEFAULT_START_DATE);
        const endDate = moment(this.getDataRangeForDistRates())

        this.setState({
            startDate,
            endDate,
            selectedStartDate: moment(startDate, DATE_FORMAT)
        }, () => this.getDateRangeData());
    }

    downloadPdf(event, name, historicalPricesType) {
        event.preventDefault();
        let startDate = moment(this.state.selectedStartDate).format("YYYY-MM-DD");
        let endDate = moment(this.state.selectedEndDate).format("YYYY-MM-DD");
        // This if statement is required, because we haven't received a launch date for the fund.
        if (moment(startDate).format("YYYY-MM-DD") === "Invalid date") {
            startDate = DEFAULT_START_DATE;
        }

        let { appParams, shareClass } = this.props;
        let { clienttype, language, productrange, region, _location, sort } = appParams;
        let isin = shareClass.clientCode;
        let baseUrl = getbaseURL();
        let url = "";
        let filename = `${name}-${shareClass.clientCode}-${startDate}-to-${endDate}`;
        if (name === "Historical-Prices") {
            url = `${baseUrl}historical-prices-pdf/DESC/${isin}/${startDate}/${endDate}/${productrange}/${region}/${clienttype}/${language}/${historicalPricesType}`;
        } else if (name === "Historical-Share-Prices") {
            url = `${baseUrl}historical-share-prices-pdf/DESC/${isin}/${startDate}/${endDate}/${productrange}/${region}/${clienttype}/${language}/${historicalPricesType}`;
        } else if (name === "Historical-Nav-Prices") {
            url = `${baseUrl}historical-nav-prices-pdf/DESC/${isin}/${startDate}/${endDate}/${productrange}/${region}/${clienttype}/${language}/${historicalPricesType}`;
        } else {
            url = `${baseUrl}distribution-rates-pdf/DESC/${isin}/${startDate}/${endDate}/${productrange}/${region}/${clienttype}/${language}`;
        }
        addItemToGoogleTracking(appParams, (name === 'Historical-Prices' || name === 'Historical-Share-Prices') ? "fund_page_historic_prices" : "fund_page_historic_distributions", { eventCategory: shareClass.clientCode, eventAction: (name === 'Historical-Prices' || name === 'Historical-Share-Prices ') ? "Historic Prices" : "Historic Distributions", eventLabel: 'Download PDF' });

        downloadPDF(url, filename);
    }

    exportCSV(event, name, historicalPricesType) {
        event.preventDefault();

        let { shareClass, fund, appParams } = this.props;
        let rows = [];
        let startDate = moment(this.state.selectedStartDate).format("YYYY-MM-DD");
        let endDate = moment(this.state.selectedEndDate).format("YYYY-MM-DD");
        let isProperty = fund.properties["asset_class"] === "Property" || shareClass.properties.fund_key === "HIT";
        // This if statement is required, because we haven't received a launch date for the fund.
        if (moment(startDate).format("YYYY-MM-DD") === "Invalid date") {
            startDate = DEFAULT_START_DATE;
        }
        let filename = `${name}-${shareClass.clientCode}-${startDate}-to-${endDate}`;
        let historicalSharePricesData = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        let historicalNavData = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
        let clientCode = fund.clientCode;
        let clientCodeList = ['CIIT'];
        let clientTypes = shareClass.properties.client_types;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        let clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);

        if (name.toLowerCase().indexOf("historical") >= 0) {
            addItemToGoogleTracking(appParams, "fund_page_historic_prices", { eventCategory: shareClass.clientCode, eventAction: "Historic Prices", eventLabel: 'Download CSV' });
            let csvHeadings = ["Fund Name", "Share Class", "Currency", "ISIN", "Date"];
            if (isProperty) {
                csvHeadings.push("Bid Price", "Offer Price");
            }
            if (!isNullOrUndefined(historicalSharePricesData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck && (historicalPricesType === "historical_share_prices")) {
                let [historicalsharePrices] = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
                csvHeadings.push("Price");
                for (let values of historicalsharePrices.values) {
                    if (moment(values.date).isBetween(startDate, endDate, null, '[]')) {
                        let row = [
                            shareClass.properties.fund_name,
                            shareClass.properties.shareclass_name,
                            historicalsharePrices.ccy,
                            shareClass.clientCode,
                            moment(values["date"]).format("DD.MM.YYYY"),
                            values["shareclass_price"],
                        ];
                        rows.push(row);
                    }
                }
            } else if (!isNullOrUndefined(historicalNavData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck && (historicalPricesType === "historical_nav_prices")) {
                csvHeadings.push("NAV Price");
                let [historicalNavPrices] = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
                for (let values of historicalNavPrices.values) {
                    if (moment(values.date).isBetween(startDate, endDate, null, '[]')) {
                        let row = [
                            shareClass.properties.fund_name,
                            shareClass.properties.shareclass_name,
                            historicalNavPrices.ccy,
                            shareClass.clientCode,
                            moment(values["date"]).format("DD.MM.YYYY"),
                            values["value"],
                        ];
                        rows.push(row);
                    }
                }
            } else {
                let [historicalPrices] = shareClass.timeseries.filter(item => item.code === "historical_prices");
                csvHeadings.push("Price");
                for (let values of historicalPrices.values) {
                    if (moment(values.date).isBetween(startDate, endDate, null, '[]')) {
                        let row = [
                            shareClass.properties.fund_name,
                            shareClass.properties.shareclass_name,
                            historicalPrices.ccy,
                            shareClass.clientCode,
                            moment(values["date"]).format("DD.MM.YYYY"),
                        ];
                        if (isProperty) {
                            row.push(values["local_bid_price"], values["local_offer_price"]);
                        } else {
                            row.push(values["shareclass_price"]);
                        }
                        rows.push(row);
                    }
                }
            }

            rows.unshift(csvHeadings);
            exportToCsv(filename, rows);
        } else {
            addItemToGoogleTracking(appParams, "fund_page_historic_distributions", { eventCategory: shareClass.clientCode, eventAction: "Historic Distributions", eventLabel: 'Download CSV' });
            let [distrobutionRates] = shareClass.timeseries.filter(item => item.code === "distribution_rates");
            let csvHeadings = [
                "Fund Name",
                "Share Class",
                "ISIN",
                "XD Date",
                "Payment Date",
				"Payment Type",
				`Income (${(shareClass.clientCode.toUpperCase() === 'GB00BFYYL325') ? '£':'pence'})`,
			];
			
            for (let values of distrobutionRates.values) {
                if (moment(values.date).isBetween(startDate, endDate, null, '[]')) {
                    rows.push([
                        shareClass.properties.fund_name,
                        shareClass.properties.shareclass_name,
                        shareClass.clientCode,
                        moment(values["xd_date"]).format("DD.MM.YYYY"),
                        moment(values["date"]).format("DD.MM.YYYY"),
                        values["payment_type"],
                        values["value"]
                    ]);
                }
            }

            rows.unshift(csvHeadings);
            exportToCsv(filename, rows);
        }
    }

    render() {
        let { isLoading, shareClass, fund, appParams } = this.props;
        let { startDate, endDate, historicalPage, historicalSharePage, distributionPage, pageLimit, sharePricesPageLimit, historicalPageAll, historicalSharePageAll, distributionPageAll, historicalNavPageAll, historicalNavPage } = this.state;
        let isProperty = fund.properties["asset_class"] === "Property" || shareClass.properties.fund_key === "HIT";
        let currencySymbol = safe(() => getCurrencySymbol(shareClass.properties.currency), { isMajor: false, value: "" });

        let historicalPricesCurrency = safe(() => shareClass.timeseries.filter(item => item.code === "historical_prices")[0].ccy, "");
        let historicalSharePricesCurrency = safe(() => shareClass.timeseries.filter(item => item.code === "historical_share_prices")[0].ccy, "");
        let historicalNavCurrency = safe(() => shareClass.timeseries.filter(item => item.code === "historical_nav_prices")[0].ccy, "");

        let historicalStart = historicalPage * pageLimit;
        let historicalSharePricesStart = historicalSharePage * sharePricesPageLimit;
        let historicalEnd = (historicalPage + 1) * pageLimit;
        let historicalSharePricesEnd = (historicalSharePage + 1) * sharePricesPageLimit;
        let historicalLength = historicalPageAll.length === 0 ? 0 : historicalPageAll.length;
        let historicalShareLength = historicalSharePageAll.length === 0 ? 0 : historicalSharePageAll.length;
        let historicalPrices: IHistoricalPrices[] = historicalPageAll.slice(historicalStart, historicalEnd);
        let historicalNavPrices: IHistoricalNavPrices[] = historicalNavPageAll.slice(historicalStart, historicalEnd);
        let historicalSharePrices: IHistoricalSharePrices[] = historicalSharePageAll.slice(historicalSharePricesStart, historicalSharePricesEnd);

        let historicalNavStart = historicalNavPage * pageLimit;
        let historicalNavEnd = (historicalNavPage + 1) * pageLimit;
        let historicalNavLength = historicalNavPageAll.length === 0 ? 0 : historicalNavPageAll.length;

        let distributionStart = distributionPage * pageLimit;
        let distributionEnd = ((distributionPage + 1) * pageLimit);
        let distributionLength = distributionPageAll.length === 0 ? 0 : distributionPageAll.length;
        let distributionRates: IDistributionRates[];

        let historicalSharePricesData = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        let clientCode = fund.clientCode;
        let clientCodeList = ['CIIT'];
        let clientTypes = shareClass.properties.client_types;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        let clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);
        if (distributionPageAll.length > 10) {
            distributionRates = distributionPageAll.slice(distributionStart, distributionEnd);
        } else {
            distributionRates = [...distributionPageAll];
        }
        let distributionImcomeType = "";
        if (distributionPageAll.length > 0) {
            distributionImcomeType = distributionPageAll[0].income_type;
		}

		const incomeHeading = `Income (${(shareClass.clientCode.toUpperCase() === 'GB00BFYYL325') ? '£' : 'pence'})`;

        return (
            <div className={styles.wrapper}>
                <div className={styles.historicChargesContainer}>
                    <BackToTop styles={backToTopstyles} />
                    <div className={styles.datePickerRow}>
                        <span>Date Range</span>
                        <div className={styles.colXs12}>
                            <Datetime
                                ref="startDate"
                                input={true}
                                isValidDate={this.checkDate}
                                value={this.state.selectedStartDate}
                                className="DatetimeHistoric"
                                onChange={this.setStartDate}
                                inputProps={{ placeholder: "From", readOnly: true }}
                                closeOnSelect={true}
                                viewMode="years"
                                dateFormat={DATE_FORMAT}
                                timeFormat={false} />
                            <Datetime
                                value={this.state.selectedEndDate}
                                input={true}
                                isValidDate={this.checkDate}
                                className="DatetimeHistoric"
                                onChange={this.setEndDate}
                                inputProps={{ placeholder: "To", readOnly: true }}
                                closeOnSelect={true}
                                viewMode="years"
                                dateFormat={DATE_FORMAT}
                                timeFormat={false} />
                        </div>
                    </div>
                    <div className={styles.row}>
                        {
                            (!isNullOrUndefined(historicalSharePricesData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck)
                                ? <div className={`${styles.colXs12} ${styles.colMd6}`}>
                                    <h2 className={`${styles.title} ${styles.reasons}`}>HISTORIC SHARE PRICES</h2>
                                    <table>
                                        <tbody>
                                            {(() => {
                                                if (isProperty) {
                                                    return (
                                                        <tr>
                                                            <th className={styles.first}>Date</th>
                                                            <th className={styles.numbers}>Currency</th>
                                                            <th className={styles.last}>Bid Price</th>
                                                            <th className={styles.last}>Offer Price</th>
                                                        </tr>
                                                    );
                                                } else {
                                                    return (
                                                        <tr>
                                                            <th className={styles.first}>Date</th>
                                                            <th className={styles.numbers}>Currency</th>
                                                            <th className={styles.last}>Price</th>
                                                        </tr>
                                                    );
                                                }
                                            })()}
                                            {historicalSharePrices.map((item) => {
                                                return (
                                                    <tr key={item.date}>
                                                        <td className={styles.first}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                        <td className={styles.numbers}>{historicalSharePricesCurrency}</td>
                                                        <td className={styles.numbers}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.shareclass_price}</NumberFormat>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {this.getPagination(historicalSharePage, historicalSharePricesStart, historicalSharePricesEnd, historicalShareLength, "HISTORIC SHARE PRICES", "historicalSharePage")}

                                    <div>
                                        <button
                                            onClick={(event) => historicalSharePrices.length > 0 ? this.downloadPdf(event, "Historical-Share-Prices", "historical_share_prices") : ""}
                                            type="button"
                                            className={`${styles.tabButtons} ${historicalShareLength === 0 ? styles.inactive : ""}`}>
                                            DOWNLOAD PDF <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                        <button
                                            onClick={(event) => historicalSharePrices.length > 0 ? this.exportCSV(event, "Historical-Share-Prices", "historical_share_prices") : ""}
                                            type="button"
                                            className={`${styles.tabButtons} ${historicalShareLength === 0 ? styles.inactive : ""}`}>
                                            DOWNLOAD CSV <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                    </div>
                                    <div className={styles.disclaimerSmall}>
                                        <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_historicprices"]} />
                                    </div>
                                </div> : ''}
                        {(!isNullOrUndefined(historicalSharePricesData) && !(clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck)
                            ? <div className={`${styles.colXs12} ${styles.colMd6}`}>
                                <h2 className={`${styles.title} ${styles.reasons}`}>HISTORIC PRICES</h2>
                                <table>
                                    <tbody>
                                        {(() => {
                                            if (isProperty) {
                                                return (
                                                    <tr>
                                                        <th className={styles.first}>Date</th>
                                                        <th className={styles.numbers}>Currency</th>
                                                        <th className={styles.last}>Bid Price</th>
                                                        <th className={styles.last}>Offer Price</th>
                                                    </tr>
                                                );
                                            } else {
                                                return (
                                                    <tr>
                                                        <th className={styles.first}>Date</th>
                                                        <th className={styles.numbers}>Currency</th>
                                                        <th className={styles.last}>Price</th>
                                                    </tr>
                                                );
                                            }
                                        })()}
                                        {historicalPrices.map((item, index) => {
                                            if (isProperty) {
                                                return (
                                                    <tr key={item.date}>
                                                        <td className={styles.first}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                        <td className={styles.numbers}>{historicalPricesCurrency}</td>
                                                        <td className={styles.last}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.local_bid_price}</NumberFormat>
                                                        </td>
                                                        <td className={styles.last}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.local_offer_price}</NumberFormat>
                                                        </td>
                                                    </tr>
                                                );
                                            } else {
                                                return (
                                                    <tr key={item.date}>
                                                        <td className={styles.first}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                        <td className={styles.numbers}>{historicalPricesCurrency}</td>
                                                        <td className={styles.numbers}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.shareclass_price}</NumberFormat>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        })}
                                    </tbody>
                                </table>

                                {this.getPagination(historicalPage, historicalStart, historicalEnd, historicalLength, "PRICES", "historicalPage")}

                                <div>
                                    <button
                                        onClick={(event) => historicalPrices.length > 0 ? this.downloadPdf(event, "Historical-Prices", "historical_prices") : ""}
                                        type="button"
                                        className={`${styles.tabButtons} ${historicalLength === 0 ? styles.inactive : ""}`}>
                                        DOWNLOAD PDF <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                    </button>
                                    <button
                                        onClick={(event) => historicalPrices.length > 0 ? this.exportCSV(event, "Historical-Prices", false) : ""}
                                        type="button"
                                        className={`${styles.tabButtons} ${historicalLength === 0 ? styles.inactive : ""}`}>
                                        DOWNLOAD CSV <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                    </button>
                                </div>
                                <div className={styles.disclaimerSmall}>
                                    <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_historicprices"]} />
                                </div>
                            </div> : ""}
                        {/* --------------- Historic Nav Table start -------------------- */}
                        {(!isNullOrUndefined(historicalNavPrices) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck)
                            ? <div className={`${styles.colXs12} ${styles.colMd6}`}>
                                <h2 className={`${styles.title} ${styles.reasons}`}>HISTORIC NAV</h2>
                                <table>
                                    <tbody>
                                        {(() => {
                                            if (isProperty) {
                                                return (
                                                    <tr>
                                                        <th className={styles.first}>Date</th>
                                                        <th className={styles.numbers}>Currency</th>
                                                        <th className={styles.last}>Bid Price</th>
                                                        <th className={styles.last}>Offer Price</th>
                                                    </tr>
                                                );
                                            } else {
                                                return (
                                                    <tr>
                                                        <th className={styles.first}>Date</th>
                                                        <th className={styles.numbers}>Currency</th>
                                                        <th className={styles.last}>Price</th>
                                                    </tr>
                                                );
                                            }
                                        })()}
                                        {historicalNavPrices.map((item, index) => {
                                            if (isProperty) {
                                                return (
                                                    <tr key={item.date}>
                                                        <td className={styles.first}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                        <td className={styles.numbers}>{historicalNavCurrency}</td>
                                                        <td className={styles.last}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.value}</NumberFormat>
                                                        </td>
                                                        <td className={styles.last}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.value}</NumberFormat>
                                                        </td>
                                                    </tr>
                                                );
                                            } else {
                                                return (
                                                    <tr key={item.date}>
                                                        <td className={styles.first}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                        <td className={styles.numbers}>{historicalNavCurrency}</td>
                                                        <td className={styles.numbers}>
                                                            <NumberFormat options={Object.assign({}, (currencySymbol.isMajor ? { prefix: currencySymbol.value } : { suffix: currencySymbol.value }))}>{item.value}</NumberFormat>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        })}
                                    </tbody>
                                </table>

                                {this.getPagination(historicalNavPage, historicalNavStart, historicalNavEnd, historicalNavLength, "HISTORIC NAV", "historicalNavPage")}

                                <div>
                                    <button
                                        onClick={(event) => historicalNavPrices.length > 0 ? this.downloadPdf(event, "Historical-Nav-Prices", "historical_nav_prices") : ""}
                                        type="button"
                                        className={`${styles.tabButtons} ${historicalNavLength === 0 ? styles.inactive : ""}`}>
                                        DOWNLOAD PDF <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                    </button>
                                    <button
                                        onClick={(event) => historicalNavPrices.length > 0 ? this.exportCSV(event, "Historical-Nav-Prices", "historical_nav_prices") : ""}
                                        type="button"
                                        className={`${styles.tabButtons} ${historicalNavLength === 0 ? styles.inactive : ""}`}>
                                        DOWNLOAD CSV <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                    </button>
                                </div>
                                <div className={styles.disclaimerSmall}>
                                    <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_historicprices"]} />
                                </div>
                            </div> : ""}
                        {/* ------------------ Historic Nav Table end ------------------- */}
                        <div className={`${styles.colXs12} ${styles.colMd6}`}>
                            <h2 className={`${styles.title} ${styles.reasons}`}>DISTRIBUTION RATES</h2>
                            <div className={styles.responsiveTable}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th className={styles.first}>XD date</th>
                                            <th className={styles.numbers}>Payment date</th>
                                            <th className={styles.numbers}>Payment type</th>
                                            <th className={styles.last}>{incomeHeading}</th>
                                        </tr>
                                        {distributionRates.map((item, index) => (
                                            <tr key={`${item.date}-${item.value}`}>
                                                <td className={styles.first}>{moment(item.xd_date).format('DD.MM.YYYY')}</td>
                                                <td className={styles.numbers}>{moment(item.date).format('DD.MM.YYYY')}</td>
                                                <td className={styles.numbers}>{item.payment_type}</td>
                                                <td className={styles.last}><NumberFormat options={{ precision: 4, showMillions: false }}>{item.value}</NumberFormat></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {this.getPagination(distributionPage, distributionStart, distributionEnd, distributionLength, "DISTRIBUTIONS", "distributionPage")}

                            <div>
                                <button
                                    onClick={(event) => distributionRates.length > 0 ? this.downloadPdf(event, "Distribution-Rates", false) : ""}
                                    type="button"
                                    className={`${styles.tabButtons} ${distributionLength === 0 ? styles.inactive : ""}`}>
                                    DOWNLOAD PDF <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                </button>
                                <button
                                    onClick={(event) => distributionRates.length > 0 ? this.exportCSV(event, "Distribution-Rates", false) : ""}
                                    type="button"
                                    className={`${styles.tabButtons} ${distributionLength === 0 ? styles.inactive : ""}`}>
                                    DOWNLOAD CSV <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                </button>
                            </div>
                            <div className={styles.disclaimerSmall}>
                                <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_distributionrate"]} />
                            </div>
                        </div>
                    </div>
                </div> {/*ends the riskrewardContainer */}
            </div>
        );
    }

    getDataRangeForDistRates() {
        let { shareClass } = this.props;
        const distributionRateValues = safe(() => shareClass.timeseries.filter(item => item.code === "distribution_rates")[0].values, []);
        let newEndDate = moment();
        if (distributionRateValues.length > 0) {
            distributionRateValues.sort((a, b) => {
                let aDate = new Date(a["xd_date"] as any).getTime();
                let bDate = new Date(b["xd_date"] as any).getTime();
                return bDate - aDate;
            });
            if (moment(distributionRateValues[0]['xd_date']).isAfter(newEndDate)) {
                newEndDate = distributionRateValues[0]['xd_date'];
            };
        }
        return newEndDate;
    }
    getDateRangeData() {
        let { shareClass } = this.props;
        let { startDate, endDate, selectedEndDate, selectedStartDate } = this.state;
        selectedStartDate = safe(() => selectedStartDate, startDate);
        selectedEndDate = safe(() => selectedEndDate, endDate);
        let today = moment();
        let validEndDate = moment(selectedEndDate).isAfter(today) ? today : selectedEndDate;
        if (moment(selectedStartDate).format("YYYY-MM-DD") === "Invalid date") {
            selectedStartDate = DEFAULT_START_DATE;
        }

        // Historical PricesTimeseries
        const historicalPricesTimeseries = safe(() => 
            shareClass.timeseries
            .filter(item => item.code === "historical_prices")[0].values, [])
            .sort((a, b) => {
                let aDate = new Date(a.date as any).getTime();
                let bDate = new Date(b.date as any).getTime();

                return bDate - aDate;
            });

        let historicalPricesAll = safe(() => {
            return historicalPricesTimeseries
                .filter(item => moment(item["date"]).isBetween(selectedStartDate, validEndDate, null, '[]'));
        }, []);

        // Historical Share Prices Timeseries
        const historicalSharePricesTimeseries = safe(() => 
            shareClass.timeseries
            .filter(item => item.code === "historical_share_prices")[0].values, [])
            .sort((a, b) => {
                let aDate = new Date(a.date as any).getTime();
                let bDate = new Date(b.date as any).getTime();

                return bDate - aDate;
            });

        let historicalSharePricesAll = safe(() => {
            return historicalSharePricesTimeseries
                .filter(item => moment(item["date"]).isBetween(selectedStartDate, validEndDate, null, '[]'));
        }, []);

        // Historical NAV Prices Timeseries
        const historicalNavPricesTimeseries = safe(() => 
            shareClass.timeseries
            .filter(item => item.code === "historical_nav_prices")[0].values, [])
            .sort((a, b) => {
                let aDate = new Date(a.date as any).getTime();
                let bDate = new Date(b.date as any).getTime();

                return bDate - aDate;
            });

        let historicalNavPricesAll = safe(() => {
            if (moment(selectedStartDate).format("YYYY-MM-DD") === "Invalid date") {
                selectedStartDate = DEFAULT_START_DATE;
            }
            return historicalNavPricesTimeseries
                .filter(item => moment(item["date"]).isBetween(selectedStartDate, validEndDate, null, '[]'));
        }, []);

         // Distribution Rates Timeseries
        const distributionRatesTimeseries = safe(() => 
            shareClass.timeseries
            .filter(item => item.code === "distribution_rates")[0].values, [])
            .sort((a, b) => {
                let aDate = new Date(a["xd_date"] as any).getTime();
                let bDate = new Date(b["xd_date"] as any).getTime();

                return bDate - aDate;
            });

        let distributionRatesAll = safe(() => {
            return distributionRatesTimeseries
                .filter(item => moment(item["xd_date"]).isBetween(selectedStartDate, selectedEndDate, null, '[]')); // Distribution rates can be in the future
        }, []);

        this.setState({
            historicalPageAll: historicalPricesAll,
            historicalSharePageAll: historicalSharePricesAll,
            distributionPageAll: distributionRatesAll,
            historicalNavPageAll: historicalNavPricesAll,
            selectedStartDate: selectedStartDate,
            selectedEndDate: selectedEndDate,
        });
    }

    getPagination(page, start, end, length, title, type) {
        return (
            <div className={styles.tablePagination}>
                <button
                    type="button"
                    onClick={(event) => this.goToStart(type)}
                    className={`${styles.tablePaginationPrev} ${page > 0 ? "" : styles.inactive} ${styles.tablePaginationStart}`}>
                    <FaAngleLeft />
                    <FaAngleLeft />
                </button>
                <button
                    type="button"
                    onClick={(event) => (page > 0 ? this.prevPage(type) : "DO_NOTHING")}
                    className={`${styles.tablePaginationPrev} ${page > 0 ? "" : styles.inactive}`}
                    disabled={page === 0}>
                    <FaAngleLeft />
                </button>

                <div className={styles.tablePaginationResults}>{start + 1}-{(end > length ? length : end)} OF {length} {title}</div>

                <button
                    type="button"
                    onClick={(event) => this.goToEnd(type)}
                    className={`${styles.tablePaginationNext} ${length - 1 >= end ? "" : styles.inactive} ${styles.tablePaginationEnd}`}>
                    <FaAngleRight />
                    <FaAngleRight />
                </button>
                <button
                    type="button"
                    onClick={(event) => (length - 1 >= end ? this.nextPage(type) : "DO_NOTHING")}
                    className={`${styles.tablePaginationNext} ${length - 1 >= end ? "" : styles.inactive}`}>
                    <FaAngleRight />
                </button>
            </div>
        );
    }

    checkDate(current) {
        let startDate = this.state.startDate ? moment(this.state.startDate) : moment(DEFAULT_START_DATE, DATE_FORMAT);
        let endDate = moment(this.state.endDate);
        return current.isBetween(startDate, endDate, 'day', '[]');
    }

    handleChangeStart(date) {
        this.setState({ startDate: date });
    }
    handleChangeEnd(date) {
        this.setState({ endDate: date });
    }

    nextPage(type) {
        this.setState({ [type]: this.state[type] + 1 });
    }

    goToEnd(type) {
        this.setState({ [type]: Math.floor(((this.state[`${type}All`].length - 1) / this.state.pageLimit)) });
    }

    prevPage(type) {
        this.setState({ [type]: this.state[type] - 1 });
    }

    goToStart(type) {
        this.setState({ [type]: 0 });
    }

    setStartDate(date) {
        this.setState({
            selectedStartDate: date
        }, () => {
            setTimeout(() => {
                this.getDateRangeData();
            }, 500);
        });
    }

    setEndDate(date) {
        this.setState({
            selectedEndDate: date
        }, () => {
            this.getDateRangeData();
            setTimeout(() => {
                this.getDateRangeData();
            }, 500);
        });
    }
}



// WEBPACK FOOTER //
// ./src/client/components/PageHistoric/index.tsx